<script>
import StatCard from '@/components/StatCard.vue';
import { useMetersStore } from '@/stores/meters.ts';

export default {
  name: 'HomeOverview',
  components: { StatCard },
  props: {
    activeView: { type: String, required: true },
  },
  data() {
    return {
      meterStore: useMetersStore(),
      kwhToCo2: 0.5,
      kwhToEuro: 0.25,
    };
  },
  methods: {
    toCurrencyString(number) {
      return '€ ' + number.toFixed(0);
    },
    toEnergyString(numberKwh) {
      return numberKwh.toFixed(0) + ' kWh';
    },
    toKgString(numberKg) {
      return numberKg.toFixed(0) + ' kg';
    },
  },
  computed: {
    subTitle() {
      return this.activeView === 'month'
        ? 'Deze maand tot nu toe opgebracht'
        : 'Totaal opgebracht';
    },
    lastMonthKwh() {
      const meterDetails = this.meterStore.getMeterDetails;
      return meterDetails.performances[meterDetails.performances.length - 1]
        .actual_yield_in_kwh;
    },
    totalKwh() {
      return this.meterStore.getMeterDetails.performances.reduce(
        (a, b) => a + b.actual_yield_in_kwh,
        0,
      );
    },
    savedString() {
      return this.activeView === 'month'
        ? this.toCurrencyString(this.lastMonthKwh * this.kwhToEuro)
        : this.toCurrencyString(this.totalKwh * this.kwhToEuro);
    },
    kwhString() {
      return this.activeView === 'month'
        ? this.toEnergyString(this.lastMonthKwh)
        : this.toEnergyString(this.totalKwh);
    },
    co2String() {
      return this.activeView === 'month'
        ? this.toKgString(this.lastMonthKwh * this.kwhToCo2)
        : this.toKgString(this.totalKwh * this.kwhToCo2);
    },
  },
};
</script>

<template>
  <div v-if="meterStore.meterDetails">
    <div id="overview" class="flex flex-col mt-2 px-7 gap-5 lg:w-2/3 ">
      <stat-card title="Energie opgebracht" :value="kwhString" icon="fa-solar-panel"/>
      <stat-card title="Geld bespaard" :value="savedString" icon="fa-piggy-bank"/>
      <stat-card title="CO2 bespaard" :value="co2String" icon="fa-leaf"/>
    </div>
  </div>
</template>

<style scoped>

</style>